<ul [class.block]="block" [class.center]="center" class="tag-list">
  @for (tag of tags; track tag) {
    <li>
      <app-tag [status]="status">{{ tag.name }}</app-tag>
    </li>
  }
</ul>
